/**
 * Created by Jerker Nord on 2021-01-28.
 */

import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {Karen} from "../Karen";
import {KarenSoundManager} from "../sound/KarenSoundManager";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {gsap} from "gsap";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {KarenReelController} from "../reels/KarenReelController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {KarenSymbol} from "../symbol/KarenSymbol";
import {KarenSoundConfig} from "../sound/KarenSoundConfig";
import {KarenGameMode} from "../server/KarenGameMode";

export class KarenNormalBetPresentation implements FlowStatePresentation {

    private _normalStartDelay: number = 0.06;
    private _fastStartDelay: number = 0.01;

    constructor() {
    }

    public start(flowStateController: FlowStateController): void {
        Karen.splashView.stopAnimation();
        Karen.miniPaytable.onNewBet();
        const tl: TimelineLite = gsap.timeline({onComplete: () => flowStateController.finish()});
        if (!SlotGame.apiPlugin.isReplay) {
            if (!Karen.model.parsedGameData) {
                //#294 fixed only complete first time game loading
                Karen.normalIdle.completeTimeline();
            }

        }
        tl.add(() => {
            if (Karen.reel2Frame) {
                Karen.reel2Frame.enabled(false);
            }
            Karen.initialCountUp.remove();
            Karen.bigWinCountUp.remove();
            Karen.background.onSpinStart();
            const ways: number = KarenReelController.currentNumData.reduce((x, y) =>
                x * y);
            if (Karen.model.data.nextMode === KarenGameMode.FREESPIN) {
                Karen.xwaysMultiplierView.setFSXWays();
                Karen.xwaysMultiplierView.hideNoOfWays();
            } else {
                Karen.xwaysMultiplierView.setXWays(ways.toString());
            }
            if (!Karen.model.parsedGameData) {
                // first time game loading
                if (Karen.model.parsedInitData.mode === GameMode.NORMAL && Karen.model.parsedInitData.nextMode !== GameMode.FREESPIN) {
                    KarenReelController.currentNumData = [2, 3, 3, 3, 3, 3];
                    Karen.reels.forEach((reel: KarenReelController, reelId: number) => {
                        Karen.reelBackground.bounceReelFrame(reelId, KarenReelController.currentNumData[reelId]);
                        reel.reelView.updateReelMask(reelId, KarenReelController.currentNumData[reelId]);
                    });
                }
            }
            KarenSoundManager.playSoundEffect(KarenSoundConfig.REELS_SPINNING);
        });
        // If reel expanded then playing reel reset sound on spin start.
        if (Karen.reelBackground.isReelExpanded() && Karen.model.gameData && Karen.model.gameData?.nextMode !== GameMode.FREESPIN) {
            KarenSoundManager.playSoundEffect(KarenSoundConfig.REEL_RESET);
        }

        Karen.reels.forEach((reel: KarenReelController, reelId: number) => {
            reel.reelView.setInteractiveSymbols(false);
            tl.add(reel.startSpin(true), ( SlotGame.apiPlugin.settings.get(APISetting.FAST_SPIN) ? this._fastStartDelay : this._normalStartDelay ) * reelId);
        });
    }
}
